import notifications from "../../../lib/notifications";
import Component from "vue-class-component";
import Vue from "vue";
import { SystemModule, OrderModule } from "@/store/modules";
import { getModule } from "vuex-module-decorators";

@Component
export default class ModalMixin extends Vue {
  orderModule: OrderModule = getModule(OrderModule);
  systemModule: SystemModule = getModule(SystemModule);
  public selectedItems: any[] = null;
  public isLoading: boolean = false;
  public localActionResults: any[] = [];

  get modalIsVisible() {
    return this.modalName === this.systemModule.modalToDisplay;
  }

  set modalIsVisible(newValue) {
    newValue;
  }

  get modalName() {
    return this.$options.name;
  }

  get modalData() {
    return this.$store.state.system.modalData;
  }

  get selectedItem() {
    return this.selectedItems && this.selectedItems.length ? this.selectedItems[0] : null;
  }

  hideModal() {
    if (this.localActionResults && this.localActionResults.length > 0) this.publishActionResults();

    this.$bvModal.hide(this.modalName);
    this.isLoading = false;
    this.localActionResults = [];
  }

  publishActionResults() {
    if (this.localActionResults.length == 1 && this.localActionResults[0].success && !this.localActionResults[0].warning) {
      let action = this.localActionResults[0];
      notifications.success("Success", action.message);
      return;
    }

    if (this.localActionResults.length == 1 && this.localActionResults[0].success && this.localActionResults[0].warning) {
      let action = this.localActionResults[0];
      notifications.warning("Warning", action.message);
      return;
    }

    this.systemModule.setActionResults(this.localActionResults);
  }

  addActionResult(result) {
    this.localActionResults.push(result);
  }

  show() {
    if (this.orderModule.loading) {
      notifications.error(
        "Loading",
        "Order must be fully loaded."
      );
      return;
    }
    this.isLoading = false;
    if (this.modalData) {
      if (this.modalData.selectedItems) {
        this.selectedItems = this.modalData.selectedItems;
      } else {
        this.selectedItems = this.modalData;
      }
    } else {
      this.selectedItems = [this.$store.state.order.currentOrder];
    }
  }

  addSelectedItem(item) {
    if (this.modalData && this.modalData.selectedItems) {
      this.orderModule.addModalOrder(item);
    }
  }

  async refreshOrders() {
    if (this.selectedItems) {
      try {
        await this.orderModule.updateOrdersAfterAction(this.selectedItems);
      } catch (ex) {
        console.error("Failed to refresh orders", ex);
      }
    }
  }
}
